import formatFieldValue from '@UI/Pages/Subjects/Shared/Fields/formatFieldValue';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';

type StoredValue = string | number | boolean | readonly string[] | null;

/**
 * The text shown for a value on a card, `null` when nothing is shown. A boolean is a flag there: it
 * shows the field's label when true and is omitted otherwise.
 */
const formatCardValue = (definition: SubjectFieldDefinitionView, value: StoredValue): string | null => {
	if (definition.nature === 'boolean') {
		return value === true ? definition.label : null;
	}

	return formatFieldValue(definition, value);
};

export default formatCardValue;
